<template>
  <section class="error-page">
    <div class="error-page__spacer" aria-hidden="true"></div>
    <div class="error-page__block" role="alert">
      <h1 class="error-page__title">{{ t.errorTitles?.[errorCode] || t.errorTitle }}</h1>
      <p class="error-page__message">{{ message }}</p>
    </div>
    <!-- A visit our fraud check stopped would only be stopped again. -->
    <button v-if="errorCode !== 'FRAUD_DETECTED'" class="btn-join btn-join--cta" type="button" @click="tryAgain">{{ t.tryAgainCta }}</button>
    <div class="error-page__spacer" aria-hidden="true"></div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useBrandStore } from '@/stores/brandStore'
import { useSubscriptionStore } from '@/stores/subscriptionStore'

const { translations: t } = storeToRefs(useBrandStore())
const { errorCode } = storeToRefs(useSubscriptionStore())

const route = useRoute()

const message = computed(() => {
  const code = errorCode.value
  if (code === 'NETWORK') return t.value.errorNetwork
  if (code === 'NO_SERVICE') return t.value.errorNoService
  return t.value.errors[code] || t.value.errorGeneric
})

// A full reload: a new attempt needs a fresh ext_ref and a fresh Evina transaction with it.
// Query is kept so attribution params (and ?brand=, ?v=) survive the retry.
function tryAgain() {
  const query = new URLSearchParams(route.query).toString()
  window.location.assign(query ? `/?${query}` : '/')
}
</script>

<style scoped>
.error-page {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.error-page__spacer {
  flex: 1;
  min-height: 24px;
}

.error-page__block {
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: center;
}

.error-page__title {
  font-family: var(--headline-font);
  font-size: 30px;
  text-transform: var(--headline-transform);
  letter-spacing: var(--headline-tracking);
}

.error-page__message {
  font-size: 15px;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.82);
}
</style>
